// import type { AssetResultMatch } from '@frameio/graphql-client/generated';
import type { AssetResultMatch } from '../../../../shared/types';

export const getFieldMatch = <T extends AssetResultMatch>(
  matches: AssetResultMatch[],
  matchType: T['__typename']
): NonNullable<T> | undefined => {
  const match = matches.find((m) => m.__typename === matchType);

  if (!match) return undefined;

  return match as T;
};
